var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("TraysFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c("br"),
      _c("MassiveActions", {
        attrs: { "selected-flows": _vm.selectedFlows, process: _vm.process },
        on: {
          "select-all": _vm.selectAllFlows,
          "massive-process": _vm.massiveProcess,
          "attempt-process": _vm.attemptProcess,
          cancel: _vm.cancelProcess
        },
        model: {
          value: _vm.selectAll,
          callback: function($$v) {
            _vm.selectAll = $$v
          },
          expression: "selectAll"
        }
      }),
      _c("FilesHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.massiveTrays, function(file) {
          return _c("FileRowMassive", {
            key: file.aprobacionId,
            attrs: {
              file: file,
              process: _vm.process,
              blockedProcess: _vm.blockedProcess
            },
            on: {
              "select-flow": _vm.selectFlow,
              "unselect-flow": _vm.unSelectFlow
            }
          })
        }),
        1
      ),
      _c(
        "b-modal",
        {
          ref: "assign",
          attrs: {
            title: "Oficinas a las que perteneces",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("ModalAssign", {
            attrs: { userCompanyGroups: _vm.userCompanyGroups },
            on: { "search-flows-office": _vm.searchFlowsByOffice }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "process",
          attrs: {
            title: _vm.titleModal,
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _vm.process === "assign"
            ? _c("ModalAssignProcess", {
                attrs: {
                  "selected-flows": _vm.selectedFlows,
                  "office-selected": _vm.groupSelected,
                  process: _vm.process
                },
                on: { "close-modal": _vm.closeModal }
              })
            : _vm._e(),
          _vm.process !== "sign" && _vm.process !== "assign"
            ? _c("ModalProcess", {
                attrs: {
                  "selected-flows": _vm.selectedFlows,
                  process: _vm.process
                },
                on: { "close-modal": _vm.closeModal }
              })
            : _vm._e(),
          _vm.process === "sign"
            ? _c("ModalSignProcess", {
                attrs: {
                  "selected-flows": _vm.selectedFlows,
                  process: _vm.process
                },
                on: { "close-modal": _vm.closeModal }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }